import {getPreference} from '@netx/core-user-next/utils/getPreference';
import {SearchPref} from '../constants';

export const simpleAssetIdSearchEnabled = () =>
	getPreference(SearchPref.SIMPLE_ASSET_ID_SEARCH_ENABLED, true);
